var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/modules/_html.js
// module id = 204
// module chunks = 0